<template>
  <div style="overflow-x: hidden">
    <section class="breadcrumb_nav">
      <div class="breadcrumb_nav_img relative">
        <img src="https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/articles/image_1668499027_21.jpg" alt="img" />
        <h2 class="breadcrumb_nav_title text-center hidden-xs">
          {{ $t("common.support") }}
        </h2>
      </div>

      <div class="breadcrumb_nav_wrap">
        <div class="container">
          <div class="row">
            <div class="col-lg-12">
              <div class="breadcrumb_nav_box">
                <ul class="breadcrumb_nav_list">
                  <li>
                    <a href="/">{{ $t("common.home") }}</a>
                  </li>

                  <li>
                    <i class="fa fa-angle-double-right"></i>
                    <span> {{ $t("common.support") }}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="custom_page_content img-res">
      <div class="container">
        <div class="clearfix">
          <div class="row clearfix">
            <div class="col-md-12 column">
              <div class="row clearfix">
                <div class="col-md-3 column">
                  <div class="thumbnail support-thumbnail">
                    <a @click="toPage('/Contact')"><img src="https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/support/1668496290_ContactUs.png" style="width: 30%" alt="Support" /></a>
                    <div class="caption">
                      <p style="text-align: center">
                        <span style="font-size: 18px"
                          ><strong
                            ><a hrefs="/Contact">
                              {{ $t("footer.fot11") }}
                            </a></strong
                          ></span
                        >
                      </p>
                    </div>
                  </div>
                </div>

                <div class="col-md-3 column">
                  <div class="thumbnail support-thumbnail">
                    <a @click="toPage('/Services')"><img src="https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/support/1668496296_CustomServices.png" style="width: 30%" alt="Support" /></a>

                    <div class="caption">
                      <p style="text-align: center">
                        <span style="font-size: 18px"
                          ><strong
                            ><a href="/Services">{{ $t("footer.fot12") }}</a></strong
                          ></span
                        >
                      </p>
                    </div>
                  </div>
                </div>

                <div class="col-md-3 column">
                  <div class="thumbnail support-thumbnail">
                    <a @click="toPage('/FAQ')"><img src="https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/support/1668496303_FAQ.png" style="width: 30%" alt="Support" /></a>

                    <div class="caption">
                      <p style="font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; color: rgb(51, 51, 51); text-align: center">
                        <span style="font-size: 18px"
                          ><strong
                            ><a>{{ $t("footer.fot13") }}</a></strong
                          ></span
                        >
                      </p>
                    </div>
                  </div>
                </div>

                <div class="col-md-3 column">
                  <div class="thumbnail support-thumbnail">
                    <a @click="toPage('/returns')"><img src="https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/support/1668496309_ReturnsExchange.png" style="width: 30%" alt="Support" /></a>

                    <div class="caption">
                      <p style="font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; color: rgb(51, 51, 51); text-align: center">
                        <span style="font-size: 18px"
                          ><strong
                            ><a>{{ $t("footer.fot14") }}</a></strong
                          ></span
                        >
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        &nbsp;

        <div class="clearfix">
          <div class="row clearfix">
            <div class="col-md-12 column">
              <div class="row clearfix">
                <div class="col-md-3 column">
                  <div class="thumbnail support-thumbnail">
                    <a @click="toPage('/Delivery')"><img src="https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/support/1668496319_ShippingDelivery.png" style="width: 30%" alt="Support" /></a>

                    <div class="caption">
                      <p style="text-align: center">
                        <span style="font-size: 18px"
                          ><strong
                            ><a @click="toPage('/Delivery')">{{ $t("footer.fot15") }}</a></strong
                          ></span
                        >
                      </p>
                    </div>
                  </div>
                </div>
                <div class="col-md-3 column">
                  <div class="thumbnail support-thumbnail">
                    <a @click="toPage('/Recycling')"><img src="https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/support/1668496362_Recycling.png" style="width: 30%" alt="Support" /></a>

                    <div class="caption">
                      <p style="font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; color: rgb(51, 51, 51); text-align: center">
                        <span style="font-size: 18px"
                          ><strong
                            ><a>{{ $t("footer.fot16") }}</a></strong
                          ></span
                        >
                      </p>
                    </div>
                  </div>
                </div>

                <div class="col-md-3 column">
                  <div class="thumbnail support-thumbnail">
                    <a @click="toPage('/Warranty')"><img src="https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/support/1668496332_Warranty.png" style="width: 30%" alt="Support" /></a>

                    <div class="caption">
                      <p style="font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; color: rgb(51, 51, 51); text-align: center">
                        <span style="font-size: 18px"
                          ><strong
                            ><a>{{ $t("footer.fot17") }}</a></strong
                          ></span
                        >
                      </p>
                    </div>
                  </div>
                </div>

                <div class="col-md-3 column">
                  <div class="thumbnail support-thumbnail">
                    <a @click="toPage('/Catalogues')"><img src="https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/support/1668496339_Catalogues.png" style="width: 30%" alt="Support" /></a>

                    <div class="caption">
                      <p style="font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; color: rgb(51, 51, 51); text-align: center">
                        <span style="font-size: 18px"
                          ><strong
                            ><a>{{ $t("footer.fot18") }}</a></strong
                          ></span
                        >
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        &nbsp;

        <div class="clearfix">
          <div class="row clearfix">
            <div class="col-md-12 column">
              <div class="row clearfix">
                <div class="col-md-3 column">
                  <div class="thumbnail support-thumbnail">
                    <a @click="toPage('/Guides')"><img src="https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/support/1668496346_ManualsUserGuides.png" style="width: 30%" alt="Support" /></a>

                    <div class="caption">
                      <p style="text-align: center">
                        <span style="font-size: 18px"
                          ><strong
                            ><a>{{ $t("footer.fot19") }}</a></strong
                          ></span
                        >
                      </p>
                    </div>
                  </div>
                </div>

                <div class="col-md-3 column">
                  <div class="thumbnail support-thumbnail">
                    <a><img src="https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/support/1668496351_NewsletterSignup.png" style="width: 30%" alt="Support" /></a>

                    <div class="caption">
                      <p style="text-align: center">
                        <span style="font-size: 18px"
                          ><strong
                            ><a>{{ $t("footer.fot20") }}</a></strong
                          ></span
                        >
                      </p>
                    </div>
                  </div>
                </div>
                <div class="col-md-3 column">
                  <div class="thumbnail support-thumbnail">
                    <a href="/Recycling"><img src="https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/support/1668496362_Recycling.png" style="width: 30%" alt="Support" /></a>
                    <div class="caption">
                      <p style="text-align: center">
                        <span style="font-size: 18px"
                          ><strong
                            ><a href="/Recycling">{{ $t("footer.fot21") }}</a></strong
                          ></span
                        >
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        &nbsp;
      </div>
    </section>
  </div>
</template>
<script>
export default {
  data() {
    return {}
  },
  methods: {
    toPage(e) {
      this.$router.push(e)
    }
  }
}
</script>
